import { NoRecordFoundV2 } from 'components/Common/Common'
import TextInputV2 from 'components/Common/TextInputV2'
import { CLIENT_TYPE } from 'config/constants'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

function Step1({ data, values, setFieldValue }) {
    return (
        <div className='pe-lg-5'>
            <div style={{ marginTop: "15px" }}>
                <h5 className="profile-title">1. PROFILE INFORMATION</h5>
                <div className="d-flex flex-column gap-4">
                    <Row>
                        <Col md="6" className='d-flex gap-4'>
                            <TextInputV2
                                required
                                name="lastname"
                                label='Last Name'
                                value={values?.lastname}
                                onChange={(e) => setFieldValue("lastname", e.target.value)}
                            />
                            <TextInputV2
                                required
                                name="firstname"
                                label='First Name'
                                value={values?.firstname}
                                onChange={(e) => setFieldValue("firstname", e.target.value)}
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="email"
                                label='Email' type='email'
                                value={values?.email}
                                disabled
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="phone"
                                label='Phone Number'
                                type='number'
                                value={values?.phone}
                                onChange={(e) => setFieldValue("phone", e.target.value)}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <TextInputV2
                                name="address1"
                                label='Address Line 1'
                                value={values?.address1}
                                onChange={(e) => setFieldValue("address1", e.target.value)}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <TextInputV2
                                label='Address Line 2'
                                name="address2"
                                value={values?.address2}
                                onChange={(e) => setFieldValue("address2", e.target.value)}

                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                label='City'
                                name="city"
                                value={values?.city}
                                onChange={(e) => setFieldValue("city", e.target.value)}

                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                name="postal_code"
                                label='Postal Code'
                                value={values?.postal_code}
                                onChange={(e) => setFieldValue("postal_code", e.target.value)}

                            />
                        </Col>
                    </Row>
                </div>
            </div>

            <div style={{ marginTop: "44px" }}>
                <h5 className="profile-title">2. EMERGENCY CONTACT INFORMATION</h5>
                <div className="d-flex flex-column gap-4">
                    <Row>
                        <Col md="6" className='d-flex gap-4'>
                            <TextInputV2
                                required
                                name="emergency_lastname"
                                label='Last Name'
                                value={values?.emergency_lastname}
                                onChange={(e) => setFieldValue("emergency_lastname", e.target.value)}
                            />
                            <TextInputV2
                                required
                                name="emergency_firstname"
                                label='First Name'
                                value={values?.emergency_firstname}
                                onChange={(e) => setFieldValue("emergency_firstname", e.target.value)}
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="emergency_email"
                                label='Email' type='email'
                                value={values?.emergency_email}
                                // disabled
                            />
                        </Col>
                        <Col md="3">
                            <TextInputV2
                                required
                                name="emergency_phone"
                                label='Phone Number'
                                type='number'
                                value={values?.emergency_phone}
                                onChange={(e) => setFieldValue("emergency_phone", e.target.value)}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <TextInputV2
                                name="emergency_relationship"
                                label='Relationship to Clinician'
                                value={values?.emergency_relationship}
                                onChange={(e) => setFieldValue("emergency_relationship", e.target.value)}

                            />
                        </Col>
                    </Row>
                </div>
            </div>

            <div>
                <Col lg="12" className="" style={{ marginTop: "44px" }}>
                    <h5 style={{ marginTop: "16px" }} className="profile-title">3. KCS INFORMATION</h5>
                </Col>
                <Row>
                    <Col sm="6" md='4'>
                        <label className="discharge-screen-label">Discipline</label><br />
                        <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{data?.therapist_detail?.therapist_discipline
                            ?.name}</p>
                    </Col>
                    <Col sm="6" md='4'>
                        <label className="discharge-screen-label">Type</label><br />
                        <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova", textTransform: "capitalize" }}>{data?.therapist_detail?.type}</p>
                    </Col>
                    <Col sm="6" md='4'>
                        <label className="discharge-screen-label">Client Category</label><br />
                        <div className="d-flex flex-column align-items-start gap-1">
                            {/* <img width={12} height={9} src={rightCheckBlue} alt="rightCheckBlue" /> */}
                            {
                                data?.therapist_detail?.assigned_client_category?.split(",")?.map((item) => (
                                    <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{CLIENT_TYPE?.[item]}</p>

                                ))
                            }
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                <Col lg="12" className="" style={{ marginTop: "44px" }}>
                    <h5 style={{ marginTop: "16px" }} className="profile-title">4.   YOUR SCHOOLS FOR CLASSROOM REPORTS</h5>
                </Col>
                {
                    values?.assign_school?.length ? values?.assign_school?.map((item) => (
                        <Row>
                            <Col lg='4'>
                                <label className="discharge-screen-label">School Divisions</label><br />
                                <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{item?.division_name}</p>
                            </Col>
                            <Col lg='4'>
                                <label className="discharge-screen-label">Schools</label><br />
                                {
                                    item?.schools?.map((list) => (
                                        <p className="discharge-screen-label mb-0" style={{ fontFamily: "Proxima Nova" }}>{list?.name}</p>
                                    ))
                                }
                            </Col>
                        </Row>
                    )) : <NoRecordFoundV2 />
                }

            </div>

        </div>
    )
}

export default Step1
